import React from "react";
import categories from "../../assets/data/category";

function CategoryList() {
  const TotalCategories = categories.length;

  return (
    <div className="MainDashboard flex items-center justify-center">
      <div className="Table lg:w-[250px] md:w-[300px] w-[350px] rounded-lg p-4 bg-white">
        <div className="flex items-center justify-between mb-2">
          <h2 className="text-lg font-semibold mb-2">Categories</h2>
          <div className="relative">
            <i
              className="fa fa-bell text-[24px] relative"
              aria-hidden="true"
            ></i>
            {TotalCategories > 0 && (
              <span className="absolute top-[-5px] right-[-5px] bg-red-600 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                {TotalCategories}
              </span>
            )}
          </div>
        </div>

        {/* Scrollable List Container */}
        <div className="overflow-y-auto" style={{ height: "250px" }}>
          <table className="w-full border-collapse text-sm">
            {/* Sticky Table Header */}
            <thead className="sticky top-0 bg-gray-200">
              <tr className="text-gray-700">
                <th className="p-2 border-b">Category</th>
                <th className="p-2 border-b">Image</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((category) => (
                <tr className="hover:bg-gray-100" key={category._id}>
                  <td className="p-2 border-b text-center">
                    {category.Category}
                  </td>
                  <td className="p-2 border-b flex items-center pl-5 ">
                    <img
                      src={category.image}
                      alt={category.Category}
                      className="w-10 h-10 object-contain rounded-md"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default CategoryList;
